module.exports = __webpack_public_path__ + "img/44.914bac8b.jpg";